(function () {
  "use strict";

  var ROOT = window.location.origin;
  var PREFERRED_BLOG_BASE = "/blogs/blog";
  var LEGACY_BLOG_BASE = "/blogs/infos";
  var LEGACY_BLOG_PREFIX = "/blogs/infos/";
  var LEGACY_BLOG_ATOM = "/blogs/infos.atom";

  function cleanArticleTitle(title) {
    if (!title) return "";
    return title
      .replace(/\s*\|\s*Anna-?Lia\s*$/i, "")
      .replace(/\s*[–-]\s*Anna-?Lia\s*$/i, "")
      .trim();
  }

  function normalizeBlogPath(path) {
    if (!path) return path;
    if (path === LEGACY_BLOG_BASE) return PREFERRED_BLOG_BASE;
    if (path === LEGACY_BLOG_ATOM) return PREFERRED_BLOG_BASE + ".atom";
    if (path.indexOf(LEGACY_BLOG_PREFIX) === 0) {
      return PREFERRED_BLOG_BASE + path.slice(LEGACY_BLOG_BASE.length);
    }
    return path;
  }

  function redirectLegacyBlogUrl() {
    var nextPath = normalizeBlogPath(window.location.pathname);
    if (nextPath && nextPath !== window.location.pathname) {
      window.location.replace(nextPath + window.location.search + window.location.hash);
      return true;
    }
    return false;
  }

  function rewriteBlogHref(rawHref) {
    if (!rawHref) return "";

    try {
      var url = new URL(rawHref, ROOT);
      var nextPath = normalizeBlogPath(url.pathname);
      if (nextPath !== url.pathname) {
        url.pathname = nextPath;
        return url.toString();
      }
    } catch (error) {
      return rawHref;
    }

    return rawHref;
  }

  function rewriteLinks() {
    var anchors = document.querySelectorAll("a[href*='/blogs/blog'], a[href*='/blogs/infos']");
    for (var i = 0; i < anchors.length; i += 1) {
      var anchor = anchors[i];
      var rawHref = anchor.getAttribute("href");
      var nextHref = rewriteBlogHref(rawHref);
      if (nextHref && nextHref !== rawHref) {
        anchor.setAttribute("href", nextHref);
      }
    }
  }

  function cleanVisibleTitles() {
    var titleLinks = document.querySelectorAll(".t4s-post-title a, .t4s-current-blog, a[href*='/blogs/blog/']");
    for (var i = 0; i < titleLinks.length; i += 1) {
      var node = titleLinks[i];
      if (!node || !node.textContent) continue;
      var cleaned = cleanArticleTitle(node.textContent);
      if (cleaned && cleaned !== node.textContent.trim()) {
        node.textContent = cleaned;
      }
    }
  }

  function run() {
    if (redirectLegacyBlogUrl()) return;
    rewriteLinks();
    cleanVisibleTitles();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run, { once: true });
  } else {
    run();
  }
})();
